/* istanbul ignore file */
import loadable from '@loadable/component';
import { fallback } from '@ldx-dmp/Loadable';

const Home = loadable(() => import('./Home'), { fallback });

export default Home;
